/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RecurringPaymentAuthorization } from '../models/recurring-payment-authorization';

/**
 * Recurring payment authorizations
 */
@Injectable({
  providedIn: 'root',
})
export class RecurringPaymentAuthorizationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation getRecurringPaymentAuthorizations
   */
  static readonly GetRecurringPaymentAuthorizationsPath =
    '/api/mobile/recurring-payment-authorizations';

  /**
   * Get active recurring payment authorizations for the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRecurringPaymentAuthorizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecurringPaymentAuthorizations$Response(params?: {
    context?: HttpContext;
  }): Observable<StrictHttpResponse<Array<RecurringPaymentAuthorization>>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      RecurringPaymentAuthorizationsService.GetRecurringPaymentAuthorizationsPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<RecurringPaymentAuthorization>>;
        })
      );
  }

  /**
   * Get active recurring payment authorizations for the current user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRecurringPaymentAuthorizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecurringPaymentAuthorizations(params?: {
    context?: HttpContext;
  }): Observable<Array<RecurringPaymentAuthorization>> {
    return this.getRecurringPaymentAuthorizations$Response(params).pipe(
      map(
        (r: StrictHttpResponse<Array<RecurringPaymentAuthorization>>) =>
          r.body as Array<RecurringPaymentAuthorization>
      )
    );
  }

  /**
   * Path part for operation revokeRecurringPaymentAuthorization
   */
  static readonly RevokeRecurringPaymentAuthorizationPath =
    '/api/mobile/recurring-payment-authorizations/{id}';

  /**
   * Revoke a recurring payment authorization.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeRecurringPaymentAuthorization()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeRecurringPaymentAuthorization$Response(params: {
    id: number;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      RecurringPaymentAuthorizationsService.RevokeRecurringPaymentAuthorizationPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: params?.context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * Revoke a recurring payment authorization.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `revokeRecurringPaymentAuthorization$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeRecurringPaymentAuthorization(params: {
    id: number;
    context?: HttpContext;
  }): Observable<void> {
    return this.revokeRecurringPaymentAuthorization$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }
}
